import { render } from "./BetHistory.vue?vue&type=template&id=ce9a295c&scoped=true&ts=true"
import script from "./BetHistory.vue?vue&type=script&lang=ts"
export * from "./BetHistory.vue?vue&type=script&lang=ts"

import "./BetHistory.vue?vue&type=style&index=0&id=ce9a295c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce9a295c"]])

export default __exports__